import React from 'react';
import MenuModal from '@/components/menus/MenuModal';
import useMenuTaxonomyList from '@/hooks/useMenuTaxonomyList';

const MenuModalContainer: React.FC = () => {
  const menuTaxonomyList = useMenuTaxonomyList();
  return <MenuModal taxonomyList={menuTaxonomyList} />;
};

export default MenuModalContainer;
